import { handleActions } from 'redux-actions';
import { failedDependentRequest } from './actions';

export default handleActions(
    {
        [failedDependentRequest]: (state, action) => ({
            ...state,
            rejectedRequestMessage: action.payload,
        }),
    },
    {},
);
